import * as microsoftTeams from "@microsoft/teams-js";
import React from 'react';
import {
  BrowserRouter as Router, Route
} from "react-router-dom";
import './App.css';
import BulkCases from './BulkCases';
import CaseDetails from './CaseDetails';
import CaseSummary from './CaseSummary';
import environment from "./environments/environment";
import Footer from './Footer'; //Include Footer
import Header from './Header'; //Include Heder
import Login from './Login';
import NewCase from './NewCase';
import Privacy from "./Privacy";
import Reports from './Reports';
import RunMetrics from './Reports/RunMetrics';
import ViewMetrics from './Reports/ViewMetrics';
import AuthService from './Services/AuthService';
import Tab from "./Tab";
import TeamsAuthPopup from './TeamsAuthPopup';
import TermsOfUse from "./TermsOfUse";
import NewUser from './Users/NewUser';
import UpdateUser from './Users/UpdateUser';
import UserCreation from './Users/UserCreation';
import UserRoles from './Users/UserRoles';
import UserSubmit from './Users/UserSubmit';
import UserSummary from './Users/UserSummary';
import LoginHistory from './LoginHistory';
import TransferCases from './transfer/TransferCases';


class App extends React.Component {

  constructor() {
    super();
    this.state = {
      authInitialized: false
    }
  }

  componentDidMount() {
    // React routing and OAuth don't play nice together
    // Take care of the OAuth fun before routing
    AuthService.init().then(() => {
      this.setState({
        authInitialized: true
      });
    })

  }
  render() {
    // alert("render -----app --->");
    if (microsoftTeams) {

      if (!this.state.authInitialized) {
        // Wait for Auth Service to initialize
        return (<div className="App"><p>Authorizing..App.</p></div>);

      } else {

        // Set app routings that don't require microsoft Teams
        // SDK functionality.  Show an error if trying to access the
        // Home page.
        if (window.parent === window.self) {
          //  alert("web ---render -----app --->");
          return (
            <div className="App">

              <Router basename={'/' + environment.ApplicationName}>
                <Header />
                <Footer />
                <Route exact path="/privacy" render={(props) => <Privacy {...props} />} />
                <Route exact path="/termsofuse" render={(props) => <TermsOfUse {...props} />} />
                <Route exact path="/teamsauthpopup" component={TeamsAuthPopup} />
                <Route exact path="/userSubmit" component={UserSubmit} />
                <Route exact path="/userRole" component={UserRoles} />
                <Route exact path="/newUser" component={NewUser} />
                <Route exact path="/userSummary" component={UserSummary} />
                <Route exact path="/newCase" render={(props) => <NewCase {...props} />} />
                <Route exact path="/caseDetails" render={(props) => <CaseDetails {...props} />} />
                <Route exact path="/reports" component={Reports} />
                <Route exact path="/bulkCases" component={BulkCases} />
                <Route exact path="/userCreation" component={UserCreation} />
                <Route exact path="/updateUser" component={UpdateUser} />
                <Route exact path="/caseSummary" component={CaseSummary} />
                <Route exact path="/RunMetrics" component={RunMetrics} />
                <Route exact path="/ViewMetrics" component={ViewMetrics} />
                <Route exact path="/loginHistory" component={LoginHistory} />
                <Route exact path="/" component={Login} />
                <Route exact path="/transferCases" component={TransferCases} />
              </Router>
            </div>
          );
        }
        // Initialize the Microsoft Teams SDK
        microsoftTeams.initialize(window);
        // Display the app home page hosted in Teams
        return (
          <div className="App">
            <Router basename={'/' + environment.ApplicationName}>
              <Header />
              <Footer />
              <Route exact path="/privacy" render={(props) => <Privacy {...props} />} />
              <Route exact path="/termsofuse" render={(props) => <TermsOfUse {...props} />} />
              <Route exact path="/teamsauthpopup" component={TeamsAuthPopup} />
              <Route exact path="/userSubmit" component={UserSubmit} />
              <Route exact path="/userRole" component={UserRoles} />
              <Route exact path="/newUser" component={NewUser} />
              <Route exact path="/userSummary" component={UserSummary} />
              <Route exact path="/newCase" render={(props) => <NewCase {...props} />} />
              <Route exact path="/caseDetails" render={(props) => <CaseDetails {...props} />} />
              <Route exact path="/reports" component={Reports} />
              <Route exact path="/bulkCases" component={BulkCases} />
              <Route exact path="/userCreation" component={UserCreation} />
              <Route exact path="/updateUser" component={UpdateUser} />
              <Route exact path="/caseSummary" component={CaseSummary} />
              <Route exact path="/RunMetrics" component={RunMetrics} />
              <Route exact path="/ViewMetrics" component={ViewMetrics} />
              <Route exact path="/loginHistory" component={LoginHistory} />
              <Route exact path="/" component={Tab} />
                <Route exact path="/transferCases" component={TransferCases} />
            </Router>
          </div>
        );
      }
    }
  }
}
export default App;
